// extracted by mini-css-extract-plugin
export default {"content":"QuickStartContent_content__uP-hQ","content-info":"QuickStartContent_content-info__2zUpm","dismissBtn":"QuickStartContent_dismissBtn__bb711"};